import isImageOpacityAllowed from 'editor/src/store/editor/selector/isImageOpacityAllowed';

import { CanShow } from 'editor/src/component/Menu/type';

import ButtonImageOpacity from './ButtonImageOpacity';
import ButtonImageOpacityDropDown from './ButtonImageOpacityDropDown';

/**
 * GAPI-61889: opt-in per host (`enableImageOpacity`); in the embedded editor only when the template
 * allows adding layers (see isImageOpacityAllowed). Only for a filled, selected image that is not
 * locked (personalization or selection lock), like the other style controls.
 */
export const canShow: CanShow = (
  state,
  { hasSelection, isElementEmpty, selectedElementType, isPersonalizationLocked, isSelectionLocked },
) =>
  isImageOpacityAllowed(state) &&
  hasSelection &&
  !isElementEmpty &&
  !isPersonalizationLocked &&
  !isSelectionLocked &&
  selectedElementType === 'image';

export { ButtonImageOpacityDropDown, ButtonImageOpacity };

export default ButtonImageOpacity;
